module.exports = __webpack_public_path__ + "img/iread.568b7cf2.png";